import { useSelector } from "react-redux";
import { RootState } from "store/reducers";
import { FacebookCrosspost } from "store/platforms/types";
import { useTranslation } from "react-i18next";
import { BaseAssignment } from "components/inputs/assignment/base-assignment";

export const CrosspostingOptions = ({
    specificDestination,
    availableCrosspostingOptions,
    selectedCrosspostingOptions,
    setSelectedCrosspostingOptions,
    setAvailableCrosspostingOptions
}) => {
    const { t } = useTranslation();
    const {
        selectedStreams: { facebook: selectedStream }
    } = useSelector((state: RootState) => state.platforms.general);

    // Only show for Facebook Pages and when not in stream selection mode
    if (
        !(
            specificDestination?.platformSpecificSettings?.edge ===
                "accounts" && selectedStream === null
        )
    ) {
        return null;
    }

    return (
        <div>
            <BaseAssignment<FacebookCrosspost>
                items={availableCrosspostingOptions || []}
                itemIdKey={"id"}
                itemLabelKey={"name"}
                labels={{
                    appliedItemsLabel: t("facebook-destination:crossposting"),
                    noItemsAppliedLabel: t(
                        "facebook-destination:no-pages-selected"
                    ),
                    selectLabel: " ",
                    selectPlaceholder: t("facebook-destination:select-page"),
                    inputLabel: t("facebook-destination:search-pages"),
                    inputPlaceholder: null
                }}
                assignedItems={selectedCrosspostingOptions || []}
                variant="search"
                handleAssignItem={(item: FacebookCrosspost) =>
                    setSelectedCrosspostingOptions(
                        !!selectedCrosspostingOptions?.length
                            ? [...selectedCrosspostingOptions, item]
                            : [item]
                    )
                }
                handleAddItem={(query: string) => {
                    setAvailableCrosspostingOptions(
                        availableCrosspostingOptions.filter(
                            (item) =>
                                !query ||
                                item.name
                                    .toLowerCase()
                                    .includes(query.toLowerCase())
                        )
                    );
                }}
                handleRemoveItem={(itemId) => {
                    setSelectedCrosspostingOptions(
                        selectedCrosspostingOptions.filter(
                            (i) => i.id !== itemId
                        )
                    );
                }}
            />
        </div>
    );
};
